module.exports = __webpack_public_path__ + "static/mono-36-07d63f9bd6d48945707a7c60c3966eb0.png";